import GetCertsResponse from 'owa-service/lib/contract/GetCertsResponse';
import getEncryptionCertsOperation from 'owa-service/lib/operation/getEncryptionCertsOperation';
import getCertsRequest from 'owa-service/lib/factory/getCertsRequest';
import EmailAddressWrapper from 'owa-service/lib/contract/EmailAddressWrapper';

/**
 * Fetches the encryption certificates for the recipients specified.
 */
const getEncryptionCerts = async (recipients: EmailAddressWrapper[]): Promise<GetCertsResponse> => {
    try {
        return await getEncryptionCertsOperation({
            request: getCertsRequest({ Recipients: recipients }),
        });
    } catch (e) {
        return null;
    }
};

export default getEncryptionCerts;
